import React, { useEffect } from "react";
import "./App.css";
import { Link, useHistory, withRouter } from "react-router-dom";
import Axios from "axios";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";

// export default withRouter (Redirect);

const Logout = (props) => {
  const history = useHistory();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [response, setResponse] = React.useState("");
  const [error, setError] = React.useState("");
  const [errorDisplay, setErrorDisplay] = React.useState("none");

  useEffect(() => {
    document.title = "Karamale - Successfully logged out";
  }, []);

  return (
    <div className="view">
      {/* <Header /> */}
      <div className="container">
        <div className="row justify-content-center login-screen-container w-100">
          <div className="align-self-center">
            {/* <div className="log-title text-center">
                <img src="https://karamale.com/karamale.png" width="170" />
              </div> */}

            <div className="text-footer text-center successfully-out">
              <IoIosCheckmarkCircleOutline size={40} />
              <br />
              <br />
              Successfully logged out
              <br />
              <br />
              <Link to="/">Home</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;
